import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "~/Hooks/useLocalStorage";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { post, put } from "~/Services";
import { passengerHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";
import { useAppAboutDocumentDetails } from "../appabout/about.hooks";
import { AppCard } from "./AppCard";

export const AppCardsMainContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();

  const {
    data: editAppAbout,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useAppAboutDocumentDetails(query.get("editId") || "");

  const {
    data: editAppAboutById,
    isLoading: isLoadingLocs,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    const activeTab = query.get("activeTab");
    if (activeTab === "appCardsMainContent") {
      refetchCategories();
    }
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("activeTab"), query.get("editId"), query.get("id")]);

  const [currentAirport] = useLocalStorage("currentAirport", null);

  const formConfig: FormConfig = {
    initialValues: {
      about_text_english: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_text_english)
        : decodeHTML(editAppAbout?.about_text_english),

      about_text_malay: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_text_malay)
        : decodeHTML(editAppAbout?.about_text_malay),

      about_text_mandarin: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_text_mandarin)
        : decodeHTML(editAppAbout?.about_text_mandarin),

      about_description_english: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_description_english)
        : decodeHTML(editAppAbout?.about_description_english),

      about_description_malay: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_description_malay)
        : decodeHTML(editAppAbout?.about_description_malay),

      about_description_mandarin: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.about_description_mandarin)
        : decodeHTML(editAppAbout?.about_description_mandarin),

      aboutImage: editAppAboutById?.payload
        ? [
            {
              uid: "-1",
              name: "aboutImage.png",
              status: "done",
              url: editAppAboutById?.payload?.aboutImage,
            },
          ]
        : editAppAbout?.aboutImage
          ? [
              {
                uid: "-1",
                name: "aboutImage.png",
                status: "done",
                url: editAppAbout?.aboutImage,
              },
            ]
          : "",

      mobile_app_desc_english: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.mobile_app_desc_english)
        : decodeHTML(editAppAbout?.mobile_app_desc_english),

      mobile_app_desc_malay: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.mobile_app_desc_malay)
        : decodeHTML(editAppAbout?.mobile_app_desc_malay),

      mobile_app_desc_mandarin: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.mobile_app_desc_mandarin)
        : decodeHTML(editAppAbout?.mobile_app_desc_mandarin),

      androidQrImage: editAppAboutById?.payload
        ? [
            {
              uid: "-1",
              name: "androidQrImage.png",
              status: "done",
              url: editAppAboutById?.payload?.androidQrImage,
            },
          ]
        : editAppAbout?.androidQrImage
          ? [
              {
                uid: "-1",
                name: "androidQrImage.png",
                status: "done",
                url: editAppAbout?.androidQrImage,
              },
            ]
          : "",

      iosQrImage: editAppAboutById?.payload
        ? [
            {
              uid: "-1",
              name: "iosQrImage.png",
              status: "done",
              url: editAppAboutById?.payload?.iosQrImage,
            },
          ]
        : editAppAbout?.iosQrImage
          ? [
              {
                uid: "-1",
                name: "iosQrImage.png",
                status: "done",
                url: editAppAbout?.iosQrImage,
              },
            ]
          : "",

      android_text_english: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.android_text_english)
        : decodeHTML(editAppAbout?.android_text_english),

      android_text_malay: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.android_text_malay)
        : decodeHTML(editAppAbout?.android_text_malay),

      android_text_mandarin: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.android_text_mandarin)
        : decodeHTML(editAppAbout?.android_text_mandarin),

      ios_text_english: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.ios_text_english)
        : decodeHTML(editAppAbout?.ios_text_english),

      ios_text_malay: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.ios_text_malay)
        : decodeHTML(editAppAbout?.ios_text_malay),

      ios_text_mandarin: editAppAboutById?.payload
        ? decodeHTML(editAppAboutById?.payload?.ios_text_mandarin)
        : decodeHTML(editAppAbout?.ios_text_mandarin),

      androidLink: editAppAboutById?.payload ? editAppAboutById?.payload?.androidLink : editAppAbout?.androidLink,

      iosLink: editAppAboutById?.payload ? editAppAboutById?.payload?.iosLink : editAppAbout?.iosLink,

      bottomImage: editAppAboutById?.payload
        ? [
            {
              uid: "-1",
              name: "bottomImage.png",
              status: "done",
              url: editAppAboutById?.payload?.bottomImage,
            },
          ]
        : editAppAbout?.aboutImage
          ? [
              {
                uid: "-1",
                name: "bottomImage.png",
                status: "done",
                url: editAppAbout?.bottomImage,
              },
            ]
          : "",
    },

    fields: fields.appCardsMainContent,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);

    let imageKeys: any = ["bottomImage", "aboutImage", "androidQrImage", "iosQrImage"];
    for (const key of imageKeys) {
      const field = data[key];

      try {
        if (Array.isArray(field)) {
          if (field.length === 0) {
            data[key] = "";
            continue;
          }
          const first = field[0];

          if (first?.originFileObj) {
            const formData = new FormData();
            formData.append("upload-file", first.originFileObj);
            formData.append("application", "PASSENGER");
            const res: any = await post("management/upload-file", formData);
            if (res) data[key] = res.response.data;
            else data[key] = "";
            continue;
          }

          if (typeof first?.url === "string") {
            if (first.url.trim() === "") {
              data[key] = "";
            } else {
              data[key] = first.url;
            }
            continue;
          }
          data[key] = "";
        } else {
          data[key] = "";
        }
      } catch (error) {
        console.error(`Error handling image field ${key}:`, error);
        data[key] = "";
      }
    }

    const payload = {
      action,
      method,
      module: "Mobile App",
      subModule: "appCardsMainContent",
      type: "DEDICATED",
      application: "PASSENGER_ECMS",
      airportName: currentAirport,
      reviewNotes,
      appList: [
        {
          appName: "PASSENGER_ECMS",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && {
          id: editAppAbout?.id || editAppAboutById?.payload?.id,
        }),
        ...data,
        published: true,
        airport: currentAirport,
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={drilldownLoading || isLoadingLocs}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${passengerHost}/api/mobile-app-about/${editAppAbout?.id || editAppAboutById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Mobile App"
      />
      <AppCard />
    </>
  );
};
